import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import AddMedia from "../screens/AddMedia.tsx";
import NodeContent from "./NodeContent.tsx";

interface NodeBodyProps {
  type: string;
  subNodeId: number;
  nodeId: number;
  parentId: string;
  nodeContent: any;
}

const NodeBody: React.FC<NodeBodyProps> = ({ nodeContent, nodeId, type, subNodeId, parentId }) => {
  const [visible, setVisible] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState<any>();
  const [mediaType, setMediaType] = useState<string>("IMAGE");

  return (
    <>
      <Dialog
        header="Media Library"
        visible={visible}
        modal
        appendTo={document.body}
        maskStyle={{
          background: "rgba(0,0,0,0.6)",
          zIndex: 9998,
        }}
        contentStyle={{ zIndex: 9999 }}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <AddMedia setVisible={setVisible} setSelectedMedia={setSelectedMedia} mediaType={mediaType} />
      </Dialog>
      <NodeContent selectedMedia={selectedMedia} parentId={parentId} nodeContent={nodeContent} type={type} openDialog={() => setVisible(true)} nodeId={nodeId} subNodeId={subNodeId} onMediaTypeChange={setMediaType} />
    </>
  )
}

export default NodeBody;
